import dayjs from "dayjs";

const getRandomRating = () => Math.floor(Math.random() * 5) + 1;

const generateRandomInstructor = () => {
  const names = [
    "Ali Khan",
    "Zainab Khan",
    "Hassan Ali",
    "Fatima Noor",
    "Omer Malik",
    "Sara Ahmed",
    "Bilal Ashraf",
    "Nida Rehman",
    "Saeed Khan",
    "Mariam Ali"
  ];

  const socialMedia = [
    { name: "Facebook", icon: "facebook-icon-url", color: "#3b5998" },
    { name: "Twitter", icon: "twitter-icon-url", color: "#1da1f2" },
    { name: "LinkedIn", icon: "linkedin-icon-url", color: "#0077b5" }
  ];

  const randomName = names[Math.floor(Math.random() * names.length)];
  return {
    name: randomName,
    profileImg: `https://example.com/images/${randomName.replace(" ", "_").toLowerCase()}.png`,
    rating: getRandomRating(),
    expert: ["Web Development", "Data Science", "Machine Learning", "Cybersecurity", "Software Engineering"],
    socialShare: socialMedia.map(social => ({
      ...social,
      link: `https://${social.name.toLowerCase()}.com/${randomName.replace(" ", "").toLowerCase()}`
    })),
    introduce: `${randomName} is a skilled instructor with a passion for teaching and expertise in various fields.`,
    bio: `${randomName} has been teaching for over 10 years and has a deep understanding of the subjects.`,
    experience: Math.floor(Math.random() * 15) + 1, // Years of experience between 1 and 15
    location: "Pakistan" // Static for simplicity, can be randomized
  };
};

const courseCategories = [
  "Web Development",
  "Data Science",
  "Machine Learning",
  "Cybersecurity",
  "Software Engineering",
  "Mobile App Development",
  "Cloud Computing",
  "Artificial Intelligence",
  "Database Management",
  "DevOps"
];

const skillLevels = [
  "Beginner",
  "Intermediate",
  "Advanced",
  "Expert",
  "Professional"
];

const languages = ["Urdu", "English", "Punjabi", "Sindhi", "Pashto"];
const targetQualifications = [
  "Matriculation",
  "Intermediate",
  "Bachelor's",
  "Master's",
  "Diploma"
];

function indexToLetter(index) {
  if (index < 0) {
      throw new Error("Index cannot be negative.");
  }

  let result = '';
  while (index >= 0) {
      // Calculate the letter for the current position
      const charCode = (index % 26) + 97; // 97 is the ASCII code for 'a'
      result = String.fromCharCode(charCode) + result;

      // Move to the next position
      index = Math.floor(index / 26) - 1; // Decrement to adjust for 0-based indexing
  }

  return result.toUpperCase(); // Convert to uppercase
}
const coursesData = Array.from({ length: 100 }, (_, index) => {
  const instructor = generateRandomInstructor(); // Generate instructor object once
  return {
    id: index + 1,
    image: `./img/homeBanner/1.png`, // Cycling through images 1 to 10
    courseHref: `/course${index + 1}`,
    courseTitle: `${indexToLetter(index)} Course Title`,
    instructorName: instructor.name, // Replace instructor with instructorName
    instructor: instructor, // Keep the whole instructor object for additional details
    instructorHref: `/course${index + 1}`,
    price: Math.random() * 188 + 1, // Random price between 1 and 188889999
    rating: getRandomRating(), // Random rating between 1 and 5
    courseCategory: courseCategories[index % courseCategories.length], // Cycling through the categories
    skillLevel: skillLevels[index % skillLevels.length], // Cycling through the skill levels
    lastDate: dayjs().add(Math.floor(Math.random() * 90) -40, 'days').format('YYYY-MM-DD'), // Random deadline
    courseStartingDate: dayjs().format('YYYY-MM-DD'),
    durationDays: Math.floor(Math.random() * 30) + 1, // Random duration days between 1 and 30
    duration: `${Math.floor(Math.random() * 25) + 1}h ${Math.floor(Math.random() * 60)}m`, // Random duration in hours and minutes
    lessons: Math.floor(Math.random() * 20) + 1, // Random lessons between 1 and 20
    quizzes: Math.floor(Math.random() * 200) + 1, // Random quizzes between 1 and 200
    descriptionText: `Description for Course Title ${index + 1}: This course covers various topics and provides comprehensive insights.`,
    descriptionHtml: `<p>Description for <strong>Course Title ${index + 1}</strong>: This course covers various topics and provides comprehensive insights.</p>`,
    prerequisites: `Basic knowledge of ${courseCategories[index % courseCategories.length]} is recommended.`,
    learningOutcomes: `By the end of this course, you will be able to...`, // Customize this further
    targetAudience: `This course is suitable for ${skillLevels[index % skillLevels.length]} learners.`,
    discount: Math.floor(Math.random() * 50), // Random discount between 0% to 50%
    courseFormat: Math.random() > 0.5 ? "Online" : "Offline", // Randomly assign format
    certificate: Math.random() > 0.5, // Randomly assign certificate availability
    accreditation: Math.random() > 0.5 ? "Accredited by ABC Institute" : "Not Accredited",
    languageOfInstruction: languages[index % languages.length], // Cycling through languages
    targetQualification: targetQualifications[index % targetQualifications.length], // Cycling through qualifications
    careerOpportunities: `This course prepares you for careers in ${courseCategories[index % courseCategories.length]}.`,
    courseFees: {
      tuition: Math.floor(Math.random() * 10000) + 1000, // Tuition fees between 1000 and 10000
      registration: Math.floor(Math.random() * 2000) + 500, // Registration fees between 500 and 2000
      materials: Math.floor(Math.random() * 1000) + 100 // Material costs between 100 and 1000
    },
    scholarships: Math.random() > 0.5 ? "Available" : "Not Available", // Randomly assign scholarship availability
    modeOfAssessment: Math.random() > 0.5 ? "Exams and Projects" : "Continuous Assessment", // Randomly assign assessment mode
    industryPartnerships: Math.random() > 0.5 ? "Partnerships with local tech companies for internships." : "No partnerships available.",
    studentSupport: "24/7 mentoring and tutoring available.", // Static for simplicity
  };
});


export default coursesData;




// Helper functions for ranking criteria
const normalizePrice = (price) => {
  return price <= 50 ? 1 : price <= 100 ? 0.75 : price <= 150 ? 0.5 : 0.25;
};

const normalizeDuration = (duration) => {
  return duration <= 10 ? 1 : duration <= 20 ? 0.75 : 0.5;
};

const technologyRelevance = (category) => {
  const advancedTechnologies = new Set([
    "Artificial Intelligence",
    "Machine Learning",
    "Quantum Computing",
    "Blockchain",
    "Cybersecurity",
    "Cloud Computing",
    "Data Science",
  ]);
  return advancedTechnologies.has(category) ? 1 : 0;
};

const isProfessionalCourse = (category) => {
  const professionalCourses = new Set([
    "Software Engineering",
    "Cybersecurity",
    "Cloud Computing",
    "Data Science",
    "AI",
    "Machine Learning",
  ]);
  return professionalCourses.has(category) ? 1 : 0;
};

// Calculate course score based on various factors
const calculateCourseScore = ({
  instructorRating,
  courseRating,
  price,
  discountAvailable,
  duration,
  accreditation,
  category,
  certificateAvailable,
  modeOfAssessment,
  careerOpportunities,
}) => {
  const priceScore = normalizePrice(price);
  const durationScore = normalizeDuration(duration);
  const techRelevanceScore = technologyRelevance(category); 
  const professionalCourseScore = isProfessionalCourse(category); 

  return (
    (instructorRating * 0.2) + // Instructor Rating
    (courseRating * 0.2) + // Course Rating
    (priceScore * 0.15) + // Price
    (discountAvailable ? 1 : 0) * 0.05 + // Discount Availability
    (durationScore * 0.1) + // Duration
    (accreditation ? 1 : 0) * 0.1 + // Accreditation
    (certificateAvailable ? 1 : 0) * 0.05 + // Certificate Availability
    (modeOfAssessment === "Exams and Projects" ? 1 : 0) * 0.05 + // Assessment Mode
    (careerOpportunities ? 1 : 0) * 0.05 + // Career Opportunities
    (techRelevanceScore * 0.1) + // Advanced Technology Relevance
    (professionalCourseScore * 0.05) // Professional Focus
  );
};

// Main function to get top 12 ranked courses
const getTopCourses = (courses) => {
  const today = dayjs();  // Get today's date

  // Filter out courses where lastDate is not in the future
  const validCourses = courses.filter(course => {
    const courseLastDate = dayjs(course.lastDate);
    return courseLastDate.isAfter(today);  // Only consider courses where lastDate > today
  });

  // Calculate the score for each course
  const scoredCourses = validCourses.map(course => ({
    ...course,
    score: calculateCourseScore(course),
  }));

  // Sort the courses by score in descending order
  const sortedCourses = scoredCourses.sort((a, b) => b.score - a.score);

  // Return the top 12 courses
  return sortedCourses.slice(0, 12);
};


// Get the top 12 courses
const top12Courses = getTopCourses(coursesData);

// Export the top12Courses
export { top12Courses };  // Named export
